import { render, staticRenderFns } from "./contextual-menu.vue?vue&type=template&id=6877a70c&scoped=true&"
import script from "./contextual-menu.vue?vue&type=script&lang=js&"
export * from "./contextual-menu.vue?vue&type=script&lang=js&"
import style0 from "./contextual-menu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./contextual-menu.vue?vue&type=style&index=1&id=6877a70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877a70c",
  null
  
)

export default component.exports